










import { Component, Vue,Prop,Watch } from 'vue-property-decorator'
import { energyTrend } from '@/api/home'
const echarts = require('echarts')
import NoData from '@/components/NoData'
@Component({
  name: 'Consumption',
  components:{NoData}
})
export default class Consumption extends Vue {
    @Prop({default:''}) code!:string
  private data : any = []
  RankingdData(e:any){
    energyTrend({
      regionCode:e,
      unitType:1
    }).then((res :any)=>{
      if(res.status == 0){
        this.data = []
        res.data.forEach((item:any) =>{
          this.data.push([ item.dateStr , Number(item.dataValue)])
        })
        this.init()
      }
    //   if(!res.data){
    //     this.data = null
    //   }
    }).catch(err =>{
        // // console.log(err)
    })
  }

  private init() {
      const main = document.getElementById('Consumption')
      // 基于准备好的dom，初始化echarts实例
      const myChart:any = echarts.init(main as HTMLDivElement)
      // 指定图表的配置项和数据
      const option = {
        tooltip: {},
        grid: {
          top:'25%',
          left: '0',
          // right: '2%',
          bottom: '3%',
          containLabel: true
        },
        // legend: {
        //   data: ['销量'],
        // },
        // barCategoryGap:'65%',
        yAxis:{
        //   inverse: true,//倒叙
          axisLabel:{
                // interval:0,
                textStyle: {
                    align:'right',
                    baseline:'middle'
                }
            }
        },
        xAxis: {
          type:'category',
          axisLine: {show: true}
        },
        series: [
          {
            name: '',
            type: 'line',
            smooth: true,
            itemStyle : {
                normal : {
                    color:'#2ec4dd',
                    lineStyle:{
                        color:'#2ec4dd'
                    },
			          },
            },
            data: this.data,
            
          }
        ],
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
  }
  updatafun(){
    setTimeout(() => {
      this.init()
    }, 0)
  }
    @Watch('code')
    onChangeData(e:any) {
        this.RankingdData(e)
    }
  mounted() {
    this.RankingdData(this.code)
  }
}


